import React, { useState, useRef, useEffect } from 'react';
import iFrameResize from 'iframe-resizer/js/iframeResizer';
import { Col, Container, Row } from '@yme/atoms/grid';
import { Image } from '@yme/atoms/image';
import { IndentWrapper } from '@yme/components/Separator';
import { IFRAME_DATA_ID } from './constants';
import { isLinkValid } from './helpers';
import { IframeStyled } from './styled';
export function Iframe(props) {
    const { link, isFullWidth, isRemoveBottomIndent, isInEditor, isIframeResizeEnabled } = props;
    const [isErrored, setIsErrored] = useState(!isLinkValid(link));
    const onError = () => setIsErrored(true);
    const iframe = useRef(null);
    useEffect(() => {
        if (isErrored || !iframe.current || !isIframeResizeEnabled) {
            return;
        }
        iFrameResize({
            checkOrigin: false,
            sizeWidth: false,
            sizeHeight: true,
        }, iframe.current);
    }, [isErrored, iframe, isIframeResizeEnabled]);
    const IframeComponent = isErrored ? (React.createElement(Image, { src: "" })) : (React.createElement(IframeStyled, { width: "100%", frameBorder: "0", isInEditor: isInEditor, scrolling: isIframeResizeEnabled ? 'no' : 'yes', onError: onError, ref: iframe, src: link }));
    if (!link) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent, dataTestId: IFRAME_DATA_ID },
        React.createElement("section", null, isFullWidth ? (IframeComponent) : (React.createElement(Container, null,
            React.createElement(Row, null,
                React.createElement(Col, null, IframeComponent)))))));
}
Iframe.displayName = 'Iframe_AEMComponent';
